import { NavLink, useNavigate } from 'react-router-dom'
import { AuthData } from '../../auth/AuthWrapper'
import { useEffect, useReducer, useState } from 'react'
import Logo from '../../assets/img/circo_color_logo2.png'
import useSession from 'react-session-hook'
import $, { cssNumber } from 'jquery'
import urls from '../constants/apiurl'
import ApiCaller from '../constants/ApiCaller'
import { showDangerToast, showToast } from '../constants/toaster'
import { useDispatch, useSelector } from 'react-redux'
import commonSlice, {
  updatePermission,
  updateUserData,
  updateLoading
} from '../../redux/features/common/commonSlice'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import Swal from 'sweetalert2'
export const Login = () => {
  const [isValidEmail, setIsValidEmail] = useState(true)
  const dispatch = useDispatch()
  const session = useSession()
  const navigate = useNavigate()
  const { login } = AuthData()
  const [rememberMe, setRememberMe] = useState(false)
  const [formData, setFormData] = useReducer(
    (formData, newItem) => {
      return { ...formData, ...newItem }
    },
    { userName: '', password: '' }
  )
  const [errorMessage, setErrorMessage] = useState(null)
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/
  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('bg-default');
    dispatch(updateLoading(false))
    const rememberMeTemp = localStorage.getItem('rememberMe')
    if (rememberMeTemp) {
      const rememberMe = JSON.parse(rememberMeTemp)
      if (rememberMe) {
        const rememberMeUserDataTemp =
          localStorage.getItem('rememberMeUserData')
        if (rememberMeUserDataTemp) {
          const rememberMeUserData = JSON.parse(rememberMeUserDataTemp)
          setFormData({
            userName: rememberMeUserData?.email,
            password: rememberMeUserData?.password
          })
          setRememberMe(true)
        }
      }
    }
  }, [])

  const fetchPermissions = async (id, token) => {
    let path = urls.fetchPermission + '/' + id
    let res = await ApiCaller.get({}, path, token)
    const response = await res.response.json()
    if (response.status == 200) {
      dispatch(updatePermission(response.data))
    }
  }

  const handleChange = event => {
    const inputValue = event.target.value
    setFormData({ userName: inputValue })

    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    setIsValidEmail(emailRegex.test(inputValue))
  }

  const handleMouseDownPassword = event => {
    event.preventDefault()
  }

  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = e => {
    e.preventDefault()
    setShowPassword(!showPassword)
  }

  const handleRememberClick = e => {
    setRememberMe(e.target.checked)
  }

  const doLogin = async () => {
    try {
      dispatch(updateLoading(true))
      const postJson = {
        email: formData.userName,
        password: formData.password
      }

      const path = urls.adminLogin
      const res = await ApiCaller.post(postJson, path)
      const response = await res.response.json()

      dispatch(updateLoading(false))

      if (response.status === 200 || response.status === '200') {
        // Store auth data
        const authData = {
          ...response.data,
          timestamp: new Date().getTime()
        }

        // Handle remember me
        if (rememberMe) {
          localStorage.setItem('rememberMe', JSON.stringify(true))
          localStorage.setItem('rememberMeUserData', JSON.stringify(postJson))
        } else {
          localStorage.removeItem('rememberMe')
          localStorage.removeItem('rememberMeUserData')
        }

        // Store essential auth data
        localStorage.setItem('userData', JSON.stringify(authData))
        localStorage.setItem('userToken', response.data.access_token)
        localStorage.setItem('permissionId', response.data.roleId)

        // Update Redux state
        dispatch(updateUserData(response.data))

        // Fetch user permissions
        await fetchPermissions(response.data.roleId, response.data.access_token)

        // Complete login
        await login(formData.userName, formData.password)
        showToast('Login successful')
        // Redirect to dashboard
        navigate('/')
      } else {
        showDangerToast(response.message || 'Login failed')
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error('Login error:', error)
      showDangerToast('An error occurred during login. Please try again.')
    }
  }

  useEffect(() => {
    let storeData = localStorage.getItem('userData')
    const element = document.getElementsByClassName('navbar-horizontal')[0]
    element.classList.add('bg-theme-color');
    if (window.location.pathname === '/login' && storeData) {
      navigate('/')
    }
  }, [])

  return (
    <>
      <div className='main-content'>
        <nav className='navbar navbar-top navbar-horizontal navbar-expand-md navbar-dark'>
          <div className='container px-4'>
            <button
              className='navbar-toggler'
              type='button'
              data-toggle='collapse'
              data-target='#navbar-collapse-main'
              aria-controls='navbarSupportedContent'
              aria-expanded='false'
              aria-label='Toggle navigation'
            >
              <span className='navbar-toggler-icon' />
            </button>
            <div className='collapse navbar-collapse' id='navbar-collapse-main'>
              <div className='navbar-collapse-header d-md-none'>
                <div className='row'>
                  <div className='col-6 collapse-brand'>
                    <a href='../index.html'>
                      <img src='../assets/img/brand/blue.png' />
                    </a>
                  </div>
                  <div className='col-6 collapse-close'>
                    <button
                      type='button'
                      className='navbar-toggler'
                      data-toggle='collapse'
                      data-target='#navbar-collapse-main'
                      aria-controls='sidenav-main'
                      aria-expanded='false'
                      aria-label='Toggle sidenav'
                    >
                      <span />
                      <span />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className='header bg-gradient-primary py-7 py-lg-8'>
          <div className='container'>
            <div className='header-body text-center mb-4'>
              <div className='row justify-content-center'>
                <div className='col-lg-5 col-md-6'>
                  <h1 className='text-white'>Welcome!</h1>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='separator separator-bottom separator-skew zindex-100'>
            <svg
              x={0}
              y={0}
              viewBox="0 0 2560 100"
              preserveAspectRatio="none"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div> */}
        </div>
        <div className='container mt--8 pb-5'>
          <div className='row justify-content-center'>
            <div className='col-lg-5 col-md-7'>
              <div className='card  shadow  theme_grid_box'>
                <div className='card-body px-lg-5 py-lg-5'>
                  <div className='text-center text-muted mb-4'>
                    <img
                      src={
                        'https://supa-dev-bucket.s3.af-south-1.amazonaws.com/admin_Logo.png'
                      }
                      width={'50%'}
                    />
                  </div>
                  <form role='form'>
                    <div className='form-group mb-3'>
                      <div className='input-group input-group-alternative' style={{ border: '1px solid #e1d5d5' }}>
                        <div className='input-group-prepend'>
                          <span className='input-group-text'>
                            <i className='ni ni-email-83' />
                          </span>
                        </div>
                        <input
                          className='form-control'
                          placeholder='Email'
                          value={formData.userName}
                          onChange={handleChange}
                          type='email'
                          style={{
                            borderColor: isValidEmail ? 'black' : 'red'
                          }}
                        />
                      </div>
                      {!formData.userName ? (
                        <>
                          <p className='custom-error-validation'>
                            Email is required*
                          </p>
                        </>
                      ) : (
                        !isValidEmail && (
                          <p className='custom-error-validation'>
                            Please enter a valid email address.
                          </p>
                        )
                      )}
                    </div>
                    <div className='form-group'>
                      <div className='input-group input-group-alternative' style={{ border: '1px solid #e1d5d5' }}>
                        <div className='input-group-prepend'>
                          <span className='input-group-text'>
                            <i className='ni ni-lock-circle-open' />
                          </span>
                        </div>
                        <input
                          className='form-control'
                          placeholder='Password'
                          value={formData.password}
                          onChange={e =>
                            setFormData({ password: e.target.value })
                          }
                          type={showPassword ? 'text' : 'password'}
                        />

                        <IconButton
                          style={{ marginRight: '1px' }}
                          aria-label='toggle password visibility'
                          onClick={togglePassword}
                          onMouseDown={handleMouseDownPassword}
                          edge='end'
                        >
                          {!showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </div>
                      {!formData.password ? (
                        <p className='custom-error-validation'>
                          Password is required*
                        </p>
                      ) : (
                        !passwordRegex.test(formData.password) && (
                          <p className='custom-error-validation'>
                            Invalid Password Format
                          </p>
                        )
                      )}
                      <p className='custom-error-validation text-muted'>
                        Hint: Password Format(One Uppercase, One lowercase, One
                        Special, One Digit and min 8 length)
                      </p>
                    </div>
                    <div className='row mt-3'>
                      <div className='col-6'>
                        <div className='custom-control-login custom-control-alternative custom-checkbox'>
                          <input
                            className='custom-control-input'
                            id=' customCheckLogin'
                            type='checkbox'
                            checked={rememberMe}
                            onChange={handleRememberClick}
                          />
                          <label
                            className='custom-control-label'
                            htmlFor=' customCheckLogin'
                          >
                            <span className='text-muted'>Remember me</span>
                          </label>
                        </div>
                      </div>
                      <div className='col-6'>
                        <NavLink
                          style={{ color: '#172b4d !important' }}
                          to={'/forgot-password'}
                          className={({ isActive }) =>
                            `nav-link${isActive ? " active" : ""}`
                          }
                        >
                          <small>Forgot password?</small>
                        </NavLink>
                      </div>
                      {/* <div className='col-6 text-right'>
                  <a href='#' className='text-light'>
                    <small>Create new account</small>
                  </a>
                </div> */}
                    </div>

                    <div className='text-center'>
                      <button
                        disabled={
                          !formData.userName ||
                          !formData.password ||
                          !isValidEmail ||
                          !passwordRegex.test(formData.password)
                        }
                        type='button'
                        className='btn btn-primary my-4'
                        onClick={doLogin}
                      >
                        Sign in
                      </button>
                    </div>
                    {errorMessage ? (
                      <div className='error'>{errorMessage}</div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <footer className='py-5'>
          <div className='container'>
            <div className='row align-items-center justify-content-xl-between'>
              <div className='col-xl-6'>
                <div className='copyright text-center text-xl-left text-muted'>
                  © 2018{' '}
                  <a
                    href='https://www.creative-tim.com'
                    className='font-weight-bold ml-1'
                    target='_blank'
                  >
                    Creative Tim
                  </a>
                </div>
              </div>
              <div className='col-xl-6'>
                <ul className='nav nav-footer justify-content-center justify-content-xl-end'>
                  <li className='nav-item'>
                    <a
                      href='https://www.creative-tim.com'
                      className='nav-link'
                      target='_blank'
                    >
                      Creative Tim
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='https://www.creative-tim.com/presentation'
                      className='nav-link'
                      target='_blank'
                    >
                      About Us
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='http://blog.creative-tim.com'
                      className='nav-link'
                      target='_blank'
                    >
                      Blog
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md'
                      className='nav-link'
                      target='_blank'
                    >
                      MIT License
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer> */}
      </div>
    </>
  )
}
